import { isH20FeatureEnabled } from '../../shared/utils/config';
import {
  TemplateRawForm,
  TemplateRawFormField
} from '../../template-form/interfaces/template-raw-form';
import { TemplateFormFieldEnum } from '../../template-form/interfaces/template-form-field';
import { EntityFormType } from '../interfaces/entity-form';
import { TemplateFormMode } from '../../template-form/interfaces/template-form';

export function EntityNameFieldFactory(
  rawForm: TemplateRawForm,
  entity: EntityFormType,
  mode: TemplateFormMode,
  entityDefaultName?: string
): TemplateRawForm {
  const formGrids = [
    {
      type: 'ENTITY_NAME',
      order: -1
    },
    ...rawForm.template.groups
  ];

  const noun = entity === 'SOURCE' ? 'Source' : 'Destination';
  const component =
    entity === 'SOURCE'
      ? TemplateFormFieldEnum.SOURCE_NAME
      : TemplateFormFieldEnum.DESTINATION_NAME;

  const nameField: TemplateRawFormField = {
    name: 'name',

    logo: rawForm.template.entity_type.logo_url,
    disabled: false,
    is_eligible_for_edit: isH20FeatureEnabled('EDIT_SOURCE_DEST_NAME') || mode === 'CREATE',
    component: {
      type: component.toString()
    },
    display_name: `${noun} Name`,
    description: `A unique name for your ${noun}`,
    required: true,
    size: 100,
    group: {
      field_order: 1,
      type: 'ENTITY_NAME'
    }
  };

  if (entityDefaultName) {
    // eslint-disable-next-line no-param-reassign
    rawForm = { ...rawForm, name: entityDefaultName };
  }

  return {
    ...rawForm,
    template: {
      ...rawForm.template,
      groups: formGrids,
      fields: [...rawForm.template.fields, nameField]
    }
  };
}
